import React, { useState, useEffect } from 'react';
import { Carousel } from 'flowbite';
import Navbar from './Navbar';
import Parralox from './Parralox';
import Principal from "../images/Principal.jpeg"
import Commitees from './Committe';
import VSPSMUNimage from "../images/VSPSMUN.jpeg"
import Secetriat from "../images/Secetriats.jpeg"

function Banner() {
    const [isNavOpen, setIsNavOpen] = useState(false);

    const toggleNav = () => {
        setIsNavOpen(!isNavOpen);
    };

    const items = [
        {
            position: 0,
            el: document.getElementById('carousel-item-1')
        },
        {
            position: 1,
            el: document.getElementById('carousel-item-2')
        },
        {
            position: 2,
            el: document.getElementById('carousel-item-3')
        },
        {
            position: 3,
            el: document.getElementById('carousel-item-4')
        },
    ];
    const options = {
        activeItemPosition: 1,
        interval: 3000,
        indicators: {
            activeClasses: 'bg-white dark:bg-gray-800',
            inactiveClasses: 'bg-white/50 dark:bg-gray-800/50 hover:bg-white dark:hover:bg-gray-800',
            items: [
                {
                    position: 0,
                    el: document.getElementById('carousel-indicator-1')
                },
                {
                    position: 1,
                    el: document.getElementById('carousel-indicator-2')
                },
                {
                    position: 2,
                    el: document.getElementById('carousel-indicator-3')
                },
                {
                    position: 3,
                    el: document.getElementById('carousel-indicator-4')
                },
            ]
        },
        // callback functions
        onNext: () => {
            console.log('next slider item is shown');
        },
        onPrev: () => {
            console.log('previous slider item is shown');
        },
        onChange: () => {
            console.log('new slider item has been shown');
        }
    };


    const carousel = new Carousel(items, options);




    return (
        <div>
            <nav className="bg-stone-50 to-white-100 border-gray-400 dark:bg-gray-900">
                <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
                    <a href="https://linktr.ee/vspsmun" className="flex items-center space-x-3 rtl:space-x-reverse">
                        <img src={VSPSMUNimage} className="h-12" alt="VSPSMUN Logo" />
                        <span className="self-center text-3xl font-sans leading-light whitespace-nowrap text-semibold dark:text-white">
                            VSPSMUN
                        </span>
                    </a>
                    <button
                        onClick={toggleNav}
                        className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                        aria-controls="navbar-default"
                        aria-expanded={isNavOpen ? 'true' : 'false'}
                    >
                        <span className="sr-only">Open main menu</span>
                        <svg
                            className="w-5 h-5"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 17 14"
                        >
                            <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M1 1h15M1 7h15M1 13h15"
                            />
                        </svg>
                    </button>
                    <div
                        className={`w-full md:block md:w-auto ${isNavOpen ? '' : 'hidden'}`}
                        id="navbar-default"
                    >
                        <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border  rounded-lg  md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 md:dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
                            <li>
                                <a
                                    href="#"
                                    className="font-serif block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white md:dark:text-blue-500"
                                    aria-current="page"
                                >
                                    Home
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#about-us"
                                    className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
                                >
                                    About
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#"
                                    className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent font-sans"
                                >
                                    The Secetriats
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#committe"
                                    className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
                                >
                                    Commitees
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.instagram.com/vspsmun/"
                                    className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
                                >
                                    Contact
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <body>


                <div class="relative">
                    <div class="absolute inset-0 bg-fixed bg-cover bg-center" style={{
                        backgroundImage: "url('https://images.unsplash.com/photo-1590274853856-f22d5ee3d228?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
                    }}></div>
                    <div class="relative z-10 h-96 flex justify-center items-center bg-black bg-opacity-70">
                        <div class="container flex flex-col justify-center items-center">
                            <h1 class="mb-4 hover:underline hover:text-blue-100 text-4xl font-extrabold tracking-tight leading-none text-white md:text-5xl lg:text-6xl">Welcome to VSPSMUN'24</h1>
                            <div class="mb-1">
                                <a href="https://linktr.ee/vspsmun" class="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-white rounded-lg bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-900">
                                    <span>Register now</span>
                                    <svg aria-hidden="true" class="ml-2 -mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>


                <div id="about-us" className="p-10 space-y-8 grid grid-cols-1 md:grid-cols-2 gap-8 bg-gradient-to-b from-blue-200 to-slate-200 font-serif flex-col-reverse">
                    <div>
                        <h1 className="text-left text-4xl font-bold text-black sm:text-6xl lg:text-7xl">
                            <div className="relative inline-flex">
                                <span className="absolute inset-x-0 bottom-0 border-b-[30px] border-[#7cb5e4]"></span>
                                <h1 className="text-left relative text-2xl font-bold text-black sm:text-2xl lg:text-2xl hover:underline">
                                    About Us
                                </h1>
                            </div>
                        </h1>
                        <p className="text-left grid-cols-2 gap-8">
                            VSPSMUN is a simulation of the United Nations held at DR VSPS Cantt, Kanpur, Uttar Pradesh, India. We believe in the great strength of youth and their ability to change the world for the better.We have introduced ten thrilling committees with minimal registration fees.We are elated to welcome you to the second edition of VSPSMUN’24, to be held on 13th and 14th April 2024 at Dr. Virendra Swarup Public School Cantt, Kanpur. We provide a platform for students to discuss and debate current global issues from the perspective of different countries, which helps enhance their public speaking, debating, and problem-solving skills.
                        </p>
                        <h1 className=" pt-7 space-y-8 text-left relative text-2xl font-semibold  sm:text-2xl lg:text-2xl hover:underline">
                            The Seceteriats
                                </h1>
                        <p class="text-gray-700 text-left grid-cols-2 gap-8">
                            1ST Row (L-R): Abhay Shukla (Head of Technical Department), Tanmay Shukla (Director General), Aanya Goel (Deputy Secretary
                            General), Manas Gupta (Secretary General), Unnati Shukla (Head of Logistics Affairs).
                            2nd Row (L-R): Vidhi Bhatia (USG for Public Relations), Shubh Gupta (USG for Finance & Marketing), Sushant Mishra (USG for
                            Conference Management), Ayush Singh Bist (USG for Media and Communication), Garv Srivastava (USG for Administration), Arth
                            Mehrotra (USG for Delegate Affairs).

                        </p>
                    </div>

                    <div className="flex flex-col justify-between">
                        <div id="default-carousel" className="relative w-full" data-carousel="slide">
                            <div className="relative h-96 overflow-hidden rounded-lg md:h-96 ">
                                <div className="duration-700 ease-in-out" data-carousel-item>
                                    <img src="" className="absolute block w-50 h-full object-cover" alt="..." />
                                </div>
                                <div className="duration-700 ease-in-out" data-carousel-item>
                                    <img src="" className="absolute block w-full h-full object-cover" alt="..." />
                                </div>
                                <div className="duration-700 ease-in-out" data-carousel-item>
                                    <img src="" className="absolute block w-full h-full object-cover" alt="..." />
                                </div>
                                <div className="duration-700 ease-in-out" data-carousel-item>
                                    <img src="" className="absolute block w-full h-full object-cover" alt="..." />
                                </div>
                                <div className="duration-700 ease-in-out" data-carousel-item>
                                    <img src={Secetriat} className="absolute block w-full h-full object-cover" alt="..." />
                                </div>
                            </div>

                            <div className="absolute z-30 flex -translate-x-1/2 bottom-5 left-1/2 space-x-3 rtl:space-x-reverse">
                                <button
                                    id="carousel-indicator-1"
                                    type="button"
                                    class="h-3 w-3 rounded-full"
                                    aria-current="true"
                                    aria-label="Slide 1"
                                ></button>
                                <button
                                    id="carousel-indicator-2"
                                    type="button"
                                    class="h-3 w-3 rounded-full"
                                    aria-current="false"
                                    aria-label="Slide 2"
                                ></button>
                                <button
                                    id="carousel-indicator-3"
                                    type="button"
                                    class="h-3 w-3 rounded-full"
                                    aria-current="false"
                                    aria-label="Slide 3"
                                ></button>
                                <button
                                    id="carousel-indicator-4"
                                    type="button"
                                    class="h-3 w-3 rounded-full"
                                    aria-current="false"
                                    aria-label="Slide 4"
                                ></button>

                            </div>

                            <button id="data-carousel-prev" type="button" className="absolute top-0 start-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none" data-carousel-prev>
                                <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none">
                                    <svg className="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 1 1 5l4 4" />
                                    </svg>
                                    <span className="sr-only">Previous</span>
                                </span>
                            </button>

                            <button id="data-carousel-next" type="button" className="absolute top-0 end-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none" data-carousel-next>
                                <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none">
                                    <svg className="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" />
                                    </svg>
                                    <span className="sr-only">Next</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>


                <div class="relative">
                    <div class="absolute inset-0 bg-fixed bg-cover bg-center" style={{
                        backgroundImage: "url('https://images.unsplash.com/photo-1590274853856-f22d5ee3d228?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
                    }}></div>
                    <div class="relative z-10 h-96 flex justify-center items-center bg-black bg-opacity-70">
                        <div class="container flex flex-col justify-center items-center">
                            <h1 class="mb-4 hover:underline hover:text-blue-100 text-4xl font-extrabold tracking-tight leading-none text-white md:text-5xl lg:text-6xl"></h1>
                            <div class="mb-1">
                            </div>
                        </div>
                    </div>
                </div>


                <div id="message" className="bg-gradient-to-b from-blue-200 to-slate-200">
                    <div class="bg-gradient-to-b from-blue-200 to-white-200  max-w-screen-xl mx-auto py-8 px-4 lg:py-16 lg:px-6">
                        <div class="text-center mb-10">
                            <h2 class="text-4xl tracking-tight font-bold font-serif text-primary-800">Message from Principal</h2>

                        </div>


                        <div class="flex flex-col md:flex-row ">

                            <div class="mr-0 md:mr-8 mb-6 md:mb-0">

                                <div class="max-w-sm bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                                    <a href="#">
                                        <img class="rounded-t-lg" src={Principal} alt="" />
                                    </a>
                                    <div class="p-5">
                                    </div>
                                </div>

                            </div>

                            <div class="sm:w-full p-1 whitespace-pre-wrap ">
                                <div class="text whitespace-normal">
                                    <p class="text-gray-700 font-serif font-semibold whitespace-pre-wrap">
                                        Greetings to everyone!!!
                                    </p>
                                    <p class="text-gray-700 font-serif font-semibold ">

                                        Dear Students,

                                        It is our great honour and privilege to invite you to the second edition of VSPSMUN 2024, an initiative
                                        to engage the young minds in intellectual discussions and deliberations for a positive change at the global
                                        level. It is a humble effort to empower future citizen with the right skills and abilities for their constructive

                                        contribution to the international community embedded in cohesion, stability, peace, prosperity and co-
                                        existence. This MUN is centered around the six core values of UN Sustainable Development Goals (SDGs): -

                                        Elevation of Global Citizenship Education, Instilling a Sense of Service, Building connected communities,
                                        Engaging the Youth, Strengthening the Higher purpose of the UN and MUN and Execution in the Face of
                                        Challenges. We hope and believe that our vision shall see its manifestation with our unabated enthusiasm for
                                        the upcoming conference scheduled for the month of April 2024. We sincerely solicit your unstinted support
                                        and cooperation for the grand success of the "VSPSMUN, 2024" Conference.
                                        We promise to uphold dignity and pride of the various international organizations simulated and leave
                                        delegates and dais members with indelible experiences. Best wishes for an intellectually stimulating
                                        conference.
                                    </p>
                                    <p class="text-gray-700 font-bold">
                                        Warm Regards,
                                        DR Sushma Mandal
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div id="committe">
                    <Commitees />
                </div>






            </body >
        </div >
    );
}

export default Banner;